<template>
  <div v-if="state.test_campaign_creation && state.test_rating">
    <div :class="stateFor(state.test_campaign_creation.available)">
      <strong>Kampány:</strong> {{ state.test_campaign_creation.current }}/<span v-html="formatMaximum(state.test_campaign_creation.maximum)"/> db
    </div>
    <div :class="stateFor(state.test_rating.available)">
      <strong>Értékelés:</strong> {{ state.test_rating.current }}/<span v-html="formatMaximum(state.test_rating.maximum)"/> db
    </div>
  </div>
</template>
<script>
import poolState from '../_poolState'
export default {
  props: {
    state: {
      required: true,
      type: Object,
      default: () => (poolState)
    }
  },
  methods: {
    stateFor(available) {
      if(available > 0) {
        return ''
      } else if(available === 0) {
        return 'text-danger'
      } else {
        return 'text-info'
      }
    },
    formatMaximum(maximum) {
      if (maximum === -1) {
        return '&infin;'
      } else {
        return maximum
      }
    }
  }
}
</script>